<template lang="pug">
page-template.px-lg-15.mb-10(title="Web Canal", fluid)
  grid-container(v-if="items[0]", cols="auto", cols-md="auto 300px")
    div
      v-responsive(v-if="!sm", :aspect-ratio="16 / 9")
        iframe.page-video-iframe.rounded(
          :src="`https://www.youtube.com/embed/${getYoutubeCode(items[0].link)}`",
          width="100%",
          height="100%",
          frameborder="0",
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
          allowfullscreen>
        )
      iframe.page-video-iframe(
        v-else,
        :src="`https://www.youtube.com/embed/${getYoutubeCode(items[0].link)}`",
        frameborder="0",
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowfullscreen>
      )
    div
      .text-h5.font-weight-bold.mb-2 Próximas
      v-card.mb-7(
        v-for="({ title, link, showFrom }, i) in items.slice(1)",
        :key="i",
        flat,
        tile
      )
        .primary--text.font-weight-bold.text-body-1 {{ title }}
        .mb-3
          v-icon.mt-n1(small, left) fas fa-calendar-day
          span {{ formatDate(showFrom) }}
        v-img(:src="getImgFromYoutubeLink(link)", :aspect-ratio="16 / 9")
  v-alert(type="info", color="grey", width="max-content")(v-else-if="!loading") Nenhuma live agendada.
</template>

<script>
import PageTemplate from "@/components/templates/Page.vue";
import { getYoutubeCode } from "@/components/utils";

const _config = {
  mod: "webcanalLives",
};

export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list.sort(
        (a, b) => new Date(b) - new Date(a)
      );
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    getYoutubeCode,
    getImgFromYoutubeLink(v) {
      return `https://i.ytimg.com/vi/${getYoutubeCode(v)}/mqdefault.jpg`;
    },
    formatDate(v) {
      return new Intl.DateTimeFormat("pt-BR", { dateStyle: "full" }).format(
        new Date(v)
      );
    },
  },
  created() {
    this.loading = true;
    this.$rest(_config.mod)
      .get()
      .then(() => (this.loading = false));
  },
  components: {
    PageTemplate,
  },
};
</script>
